<div class="h-full w-full p-6 lg:p-10 flex flex-col bg-body-background relative overflow-x-hidden min-h-0">

  @if (isLoading()) {
  <div class="flex items-center justify-center p-20 w-full h-full">
    <i class="fas fa-circle-notch fa-spin text-5xl text-primary"></i>
  </div>
  } @else {

  <div class="sticky top-0 z-40 bg-body-background pb-4 pt-2 border-b border-secondary-border flex flex-col gap-4">
    <button (click)="goBack()"
            class="flex items-center gap-2 text-secondary-text hover:text-primary transition-colors focus:outline-none w-max">
      <i class="fas fa-arrow-left"></i>
      <span class="font-medium text-sm">Back to Details</span>
    </button>
    <div class="flex flex-col gap-2">
      <h1 class="text-3xl font-extrabold text-heading tracking-tight">
        {{ config.texts.integrationPageTitle }}
      </h1>
      <p class="text-secondary-text">{{ config.texts.integrationPageSubtitle }}</p>
    </div>

    @if (uiState() === 'confirm') {
    <div class="flex items-center gap-4 mt-2">
      <button nz-button
              nzType="default"
              (click)="goBack()"
              class="border-secondary-border text-secondary-text bg-button-bg px-6 py-3 h-auto text-base shadow-sm">{{
        config.texts.integrationBtnNo }}</button>
      <button nz-button
              nzType="primary"
              (click)="applyIntegration()"
              class="bg-primary text-primary-button-text font-bold border-none shadow-sm px-6 py-3 h-auto text-base"><i
           class="fas fa-magic mr-2"></i> {{ config.texts.integrationBtnYes }}</button>
    </div>
    }
  </div>

  <div class="flex flex-col w-full max-w-7xl mx-auto gap-8 pb-16 mt-6">

    @if (uiState() === 'confirm') {
    <div class="flex flex-col gap-6 animate-fade-in-up">
      <p class="text font-bold text-primary-text">
        <i class="fas fa-info-circle text-primary mr-2"></i>
        {{ config.texts.integrationStep1Desc }}
      </p>

      <div class="w-full border border-primary-border rounded-xl shadow-sm overflow-hidden relative bg-component-inner">
        <rapider-data-templates-preview [previewData]="templateData()"
                                        [hideActions]="true"
                                        class="h-full w-full block"></rapider-data-templates-preview>
      </div>
    </div>
    }

    @if (uiState() === 'processing') {
    <div class="flex flex-col items-center justify-center p-12 text-center animate-fade-in-up w-full min-h-[300px]">
      <div class="relative w-24 h-24 flex items-center justify-center mb-8">
        <div class="absolute inset-0 border-4 border-secondary-border rounded-full"></div>
        <div class="absolute inset-0 border-4 border-primary rounded-full border-t-transparent animate-spin"></div>
        <i class="fas fa-cogs text-3xl text-primary animate-pulse"></i>
      </div>
      <h2 class="text-2xl font-bold text-heading mb-3 transition-all duration-300">
        {{ config.texts.processingTitle }}
      </h2>
      <p class="text-secondary-text max-w-md mb-6">
        <i class="fas fa-info-circle text-primary mr-2"></i>
        {{ config.texts.processingDesc }}
      </p>
    </div>
    }

    @if (uiState() === 'success') {
    <div class="flex flex-col items-center justify-center p-12 text-center animate-fade-in-up w-full min-h-[300px]">
      <div class="w-24 h-24 bg-success/10 rounded-full flex items-center justify-center mb-6 shadow-sm">
        <i class="fas fa-check text-4xl text-success"></i>
      </div>
      <h2 class="text-2xl font-bold text-heading mb-3">
        {{ config.texts.integrationSuccessTitle }}
      </h2>
      <p class="text-secondary-text max-w-md mb-8">
        {{ config.texts.integrationSuccessDesc }}
      </p>
      <button nz-button
              nzType="primary"
              (click)="navigateToDatabase()"
              class="bg-primary text-primary-button-text font-bold border-none shadow-sm px-6 py-3 h-auto text-base">
        {{ config.texts.integrationNavigateDbBtn }}
      </button>
    </div>
    }

    @if (uiState() === 'error') {
    <div class="flex flex-col items-center justify-center p-12 text-center animate-fade-in-up w-full min-h-[300px]">
      <div class="w-24 h-24 bg-danger/10 rounded-full flex items-center justify-center mb-6 shadow-sm">
        <i class="fas fa-times text-4xl text-danger"></i>
      </div>
      <h2 class="text-2xl font-bold text-heading mb-3">
        {{ config.texts.integrationErrorTitle }}
      </h2>
      <p class="text-secondary-text max-w-md mb-8">
        {{ config.texts.integrationErrorDesc }}
      </p>
      <div class="flex gap-4">
        <button nz-button
                nzType="default"
                (click)="retryIntegration()"
                class="border-secondary-border text-secondary-text bg-button-bg px-6 py-3 h-auto text-base shadow-sm">
          Retry
        </button>
        <button nz-button
                nzType="primary"
                (click)="navigateToDatabase()"
                class="bg-primary text-primary-button-text font-bold border-none shadow-sm px-6 py-3 h-auto text-base">
          {{ config.texts.integrationNavigateDbBtn }}
        </button>
      </div>
    </div>
    }

  </div>
  }
</div>